import { useState, useEffect, useCallback } from 'react';
import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { BaseDialog } from './base';
import { dialogService } from 'services';

export function ConfirmDialog() {
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    description: '',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    loading: false,
  });

  useEffect(() => dialogService.subscribe(setDialog), []);

  const handleConfirm = useCallback(() => dialogService.handleConfirm(), []);
  const handleClose = useCallback(() => dialogService.handleClose(), []);

  return (
    <BaseDialog open={dialog.open} onClose={handleClose} title={dialog.title}>
      <DialogContent>
        <DialogContentText>{dialog.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          variant="outlined" 
          onClick={handleClose} 
          disabled={dialog.loading}
        >
          {dialog.cancelLabel}
        </Button>
        <Button 
          variant="contained" 
          onClick={handleConfirm} 
          disabled={dialog.loading}
        >
          {dialog.confirmLabel}
        </Button>
      </DialogActions>
    </BaseDialog>
  );
}